<template>
  <div class="smsc-container">
    <vx-card>
        <div class="ml-1 mb-6">
            <span class="ml-6">Upload Number File</span>
            <div class="ml-6 mt-2">
                <input class="form-control w-25" type="file" id="formFile">
            </div>
        </div>
        <div class="ml-1 mb-6">
            <span class="ml-6">Assign Number to this vendors if number does not already exist</span>
            <div class="ml-6 mt-2">
                <input class="form-control w-25" type="file" id="formFile">
            </div>
        </div>
        <div class="ml-1 mb-6">
            <vs-button class="ml-6">Submit</vs-button>
        </div>                        
    </vx-card>
  </div>
</template>

<script>
// Packages
import vSelect from 'vue-select'
import Vue from 'vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import { FormGroupPlugin } from 'bootstrap-vue'
Vue.use(FormGroupPlugin)
// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
export default {
  components: {
    vSelect,
    Vue,
    
  },
  data() {
    return {
      // Dropdowns
      resellers: [],
       file1: null,
        file2: null,  
      // Selects value
      selects: {
        reseller_uuid: null,
      },

      // Request body
      payload: {
        amount: null,
        company_uuid: null,
        method: "manual",
        reseller_uuid: null
      },
      // input_fields: [
      //   [
      //     {
      //       field_type: 'input',
      //       field_name: 'amount',
      //       type: 'text',
      //       label: 'Amount',
      //       placeholder: 'Enter amount',
      //       value: '',
      //       is_required: true,
      //       is_valid: true,
      //       danger_text: 'The amount field is required.'
      //     }
      //   ],
      //   [
      //     {
      //       field_type: 'select',
      //       field_name: 'reseller_uuid',
      //       type: 'text',
      //       label: 'Reseller',
      //       options: [],
      //       value: { label: 'Select Reseller', value: null },
      //       is_required: true,
      //       is_valid: true,
      //       danger_text: 'The reseller is required.'
      //     }
      //   ]
      // ]
    }
  },
  created() {
    this.FetchData()
  },
  methods: {
    async FetchData() {
      this.$vs.loading()
      const { total: TotalForReseller } = await this.$store.dispatch('reseller/GetList', { per_page: 0, page: 0 })
      const p1 = await this.$store.dispatch('reseller/GetList', { per_page: TotalForReseller, page: 0 })

      Promise.all([p1])
      .then(res => {
        this.resellers = res[0].items.map(this.TransformReseller)
      })
      .catch(err => this.ShowErrorMessage({ title: 'Error', text: err }))
      .finally(() => this.$vs.loading.close())
    },
    async Add() {
      const valid = await this.$validator.validate()
      
      if (!valid) {
        return
      }

      this.$vs.loading()
      this.$store.dispatch('payment/Add', this.payload)
      .then(res => {
        if (res.success) {
          this.$router.push({ name: 'admin-reseller-list' })
          this.ShowSuccessMessage({ title: 'Success', text: 'Manual Payment has been added' })
        }
      })
      .catch(err => this.ShowErrorMessage({ title: 'Error', text: err }))
      .finally(() => this.$vs.loading.close())
    },

    // Notify
    ShowSuccessMessage ({ title, text }) {
      this.$vs.notify({
        iconPack: 'feather',
        icon: 'icon-check',
        color: 'success',
        title,
        text
      })
    },
    ShowErrorMessage ({ title, text }) {
      this.$vs.notify({
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger',
        title,
        text
      })
    },

    // Transform functions
    TransformReseller(item) {
      return {
        name: item.reseller_name,
        value: item.reseller_uuid
      }
    },
     chooseFiles: function() {
        document.getElementById("fileUpload").click()
    },
  }
}
</script>

